function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @module ol/render/canvas/ZIndexContext
 */

import { getSharedCanvasContext2D } from '../../dom.js';

/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */

/**
 * @extends {CanvasRenderingContext2D}
 */
var ZIndexContext = /*#__PURE__*/function () {
  function ZIndexContext() {
    var _this = this;
    _classCallCheck(this, ZIndexContext);
    /**
     * @private
     * @param {...*} args Args.
     * @return {ZIndexContext} This.
     */
    _defineProperty(this, "pushMethodArgs_", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.instructions_[_this.zIndex + _this.offset_].push(args);
      return _this;
    });
    /**
     * @private
     * @type {Array<Array<*>>}
     */
    this.instructions_ = [];
    /**
     * @type {number}
     */
    this.zIndex = 0;
    /**
     * @private
     * @type {number}
     */
    this.offset_ = 0;

    /**
     * @type {ZIndexContextProxy}
     */
    this.context_ = /** @type {ZIndexContextProxy} */
    new Proxy(getSharedCanvasContext2D(), {
      get: function get(target, property) {
        if (typeof (/** @type {*} */getSharedCanvasContext2D()[property]) !== 'function') {
          // we only accept calling functions on the proxy, not accessing properties
          return undefined;
        }
        if (!_this.instructions_[_this.zIndex + _this.offset_]) {
          _this.instructions_[_this.zIndex + _this.offset_] = [];
        }
        _this.instructions_[_this.zIndex + _this.offset_].push(property);
        return _this.pushMethodArgs_;
      },
      set: function set(target, property, value) {
        if (!_this.instructions_[_this.zIndex + _this.offset_]) {
          _this.instructions_[_this.zIndex + _this.offset_] = [];
        }
        _this.instructions_[_this.zIndex + _this.offset_].push(property, value);
        return true;
      }
    });
  }
  return _createClass(ZIndexContext, [{
    key: "pushFunction",
    value:
    /**
     * Push a function that renders to the context directly.
     * @param {function(CanvasRenderingContext2D): void} render Function.
     */
    function pushFunction(render) {
      this.instructions_[this.zIndex + this.offset_].push(render);
    }

    /**
     * Get a proxy for CanvasRenderingContext2D which does not support getting state
     * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
     * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
     * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
     * @return {ZIndexContextProxy} Context.
     */
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context_;
    }

    /**
     * @param {CanvasRenderingContext2D} context Context.
     */
  }, {
    key: "draw",
    value: function draw(context) {
      this.instructions_.forEach(function (instructionsAtIndex) {
        for (var i = 0, ii = instructionsAtIndex.length; i < ii; ++i) {
          var property = instructionsAtIndex[i];
          if (typeof property === 'function') {
            property(context);
            continue;
          }
          var instructionAtIndex = instructionsAtIndex[++i];
          if (typeof (/** @type {*} */context[property]) === 'function') {
            /** @type {*} */context[property].apply(context, _toConsumableArray(instructionAtIndex));
          } else {
            if (typeof instructionAtIndex === 'function') {
              /** @type {*} */context[property] = instructionAtIndex(context);
              continue;
            }
            /** @type {*} */
            context[property] = instructionAtIndex;
          }
        }
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.instructions_.length = 0;
      this.zIndex = 0;
      this.offset_ = 0;
    }

    /**
     * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
     * avoid conflicting context.clip() or context.save()/restore() calls.
     */
  }, {
    key: "offset",
    value: function offset() {
      this.offset_ = this.instructions_.length;
      this.zIndex = 0;
    }
  }]);
}();
export default ZIndexContext;